import { IconButton } from "@mui/material";
import cn from "classnames";

export const BrandIconButton = ({
  children,
  className,
  isDisabled,
  ...props
}) => {
  return (
    <IconButton
      className={cn("brand-icon-button", className)}
      {...props}
      disabled={isDisabled}
    >
      {children}
    </IconButton>
  );
};
